import React, { FC, memo, useMemo } from 'react';
import { TableCell, Typography } from '@material-ui/core';
import { Quotation } from 'src/types';
import { formatCurrency } from 'src/utils';
import useQuotationProduct from 'src/hooks/quotation-v2/use-quotation-products';

interface Props {
  quotation: Quotation;
  isScreenCapture: boolean;
}

const Component: FC<Props> = ({ quotation, isScreenCapture }) => {
  const { quotationParams } = useQuotationProduct();

  const totalPrice = useMemo(() => {
    if (quotation && quotation?.product?.retail_price) {
      return quotationParams?.is_srp
        ? +(quotation.product.retail_price * 1.12).toFixed(2) *
            quotation?.quantity
        : quotation.product.retail_price * quotation.quantity;
    }
    return 0;
  }, [quotation, quotationParams.is_srp]);

  return (
    <TableCell
      style={{
        padding: '4px 6px',
        width: '80px',
        minWidth: '100px',
        maxWidth: '100px',
        textAlign:
          quotationParams.is_srp && !isScreenCapture ? 'right' : 'left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }}
    >
      <Typography
        variant="body2"
        style={{
          fontSize: '0.9rem',
          fontWeight: 500,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}
        title={formatCurrency(totalPrice)}
      >
        {formatCurrency(totalPrice)}
      </Typography>
    </TableCell>
  );
};

export const QuotationTotalCell = memo(Component);
